import { useAnalyticsPageview } from "@/lib/analytics";

/**
 * AnalyticsListener — invisible component that fires a GA4 `page_view`
 * on every React Router route change. Mount once inside <BrowserRouter>.
 *
 * The base gtag snippet in `public/index.html` initialises GA with
 * `send_page_view: false` so this hook is the single source of truth for
 * pageview tracking (no duplicates).
 */
export default function AnalyticsListener() {
  useAnalyticsPageview();
  return null;
}
